module.exports = __webpack_public_path__ + "static/media/search_staff.39bc1806.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/search_staff.svg
// module id = 2718
// module chunks = 0